























import { mapMutations, mapGetters } from 'vuex'
import { Component, Vue } from 'vue-property-decorator'
import { checkForUpdates, applyUpdate } from '@/api/system'

enum AlertType {
  'info' = 'info',
  'error' = 'error',
  'success' = 'success',
  'warning' = 'warning'
}
enum UpdateCheckAnswer {
  Available = 'Available',
  UpToDate = 'UpToDate',
  Error = 'Error'
}

@Component({
  name: 'Update'
})
export default class extends Vue {
  private isLoadingCheck = false
  private isLoadingApply = false
  showAlert = false
  showAlert2 = false
  showAlert3 = false
  alertText = ''
  alertText2 = ''
  alertText3 = ''
  alertType: AlertType = AlertType.info
  alertType2: AlertType = AlertType.info
  alertType3: AlertType = AlertType.info
  async checkUpdates() {
    this.showAlert = false
    this.showAlert2 = false
    this.showAlert3 = false
    this.isLoadingCheck = true
    try {
      const { data } = await checkForUpdates()
      if (data.successful) {
        const UpdateMsgServer: UpdateCheckAnswer = data.answer.server
        const UpdateMsgCP: UpdateCheckAnswer = data.answer.cp
        const UpdateMsgFrontend: UpdateCheckAnswer = data.answer.frontend
        const logs = data.answer.log
        switch (UpdateMsgServer) {
          case UpdateCheckAnswer.Available:
            this.alertType = AlertType.info
            this.alertText = 'Server: Aktualisierung verfügbar!\n\n Änderungen:\n'
            for (const log of logs.server) {
              this.alertText += log + '\n'
            }
            break
          case UpdateCheckAnswer.UpToDate:
            this.alertType = AlertType.success
            this.alertText = 'Server: aktuell.'
            break
          case UpdateCheckAnswer.Error:
            this.alertType = AlertType.error
            this.alertText = 'Server: Automatisches Update nicht möglich.'
            break
          default:
            this.alertType = AlertType.error
            this.alertText = 'Server: Unknown answer:' + UpdateMsgServer
            break
        }
        switch (UpdateMsgCP) {
          case UpdateCheckAnswer.Available:
            this.alertType2 = AlertType.info
            this.alertText2 = 'Control Panel: Aktualisierung verfügbar!\n\n Änderungen:\n'
            for (const log of logs.cp) {
              this.alertText2 += log + '\n'
            }
            break
          case UpdateCheckAnswer.UpToDate:
            this.alertType2 = AlertType.success
            this.alertText2 = 'Control Panel: aktuell.'
            break
          case UpdateCheckAnswer.Error:
            this.alertType2 = AlertType.error
            this.alertText2 = 'Control Panel: Automatisches Update nicht möglich.'
            break
          default:
            this.alertType2 = AlertType.error
            this.alertText2 = 'Control Panel: Unknown answer:' + UpdateMsgCP
            break
        }
        switch (UpdateMsgFrontend) {
          case UpdateCheckAnswer.Available:
            this.alertType3 = AlertType.info
            this.alertText3 = 'Frontend: Aktualisierung verfügbar!\n\n Änderungen:\n'
            for (const log of logs.frontend) {
              this.alertText3 += log + '\n'
            }
            break
          case UpdateCheckAnswer.UpToDate:
            this.alertType3 = AlertType.success
            this.alertText3 = 'Frontend: aktuell.'
            break
          case UpdateCheckAnswer.Error:
            this.alertType3 = AlertType.error
            this.alertText3 = 'Frontend: Automatisches Update nicht möglich.'
            break
          default:
            this.alertType3 = AlertType.error
            this.alertText3 = 'Frontend: Unknown answer:' + UpdateMsgFrontend
            break
        }

        this.showAlert = true
        this.showAlert2 = true
        this.showAlert3 = true
      } else {
        //
        switch (data.reason) {
          case 'isWindowsMachine':
            this.alertType = AlertType.info
            this.alertText = 'Der Testserver auf Windows kann nicht auf Updates überprüft werden.'
            break

          default:
            this.alertText = 'Unbekannter Fehler.'
            this.alertType = AlertType.error
            break
        }
        this.showAlert = true
      }
      this.isLoadingCheck = false
    } catch (error) {
      this.isLoadingCheck = false
    }
  }
  async applyUpdates() {
    this.isLoadingApply = true
    try {
      const { data } = await applyUpdate()
      if (data.successful) {
        const UpdateMsg: UpdateCheckAnswer = data.answer
        switch (UpdateMsg) {
          case UpdateCheckAnswer.Available:
            this.alertType = AlertType.info
            this.alertText = 'Es ist eine Aktualisierung verfügbar!'
            break
          case UpdateCheckAnswer.UpToDate:
            this.alertType = AlertType.success
            this.alertText = 'Der Shop ist auf der aktuellen Version!'
            break
          case UpdateCheckAnswer.Error:
            this.alertType = AlertType.error
            this.alertText = 'Automatisches Update nicht möglich.'
            break

          default:
            this.alertType = AlertType.error
            this.alertText = 'Unknown answer:' + UpdateMsg
            break
        }
        this.showAlert = true
      } else {
        switch (data.reason) {
          case 'isWindowsMachine':
            this.alertType = AlertType.info
            this.alertText = 'Der Testserver auf Windows kann nicht aktualisiert werden.'
            break

          default:
            this.alertText = 'Unbekannter Fehler.'
            this.alertType = AlertType.error
            break
        }
        this.showAlert = true
      }
      this.isLoadingApply = false
    } catch (error) {
      this.isLoadingApply = false
    }
  }
}
